import styled from 'styled-components'

import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const Wrapper = styled.div`
    width: 100%;
    background: ${(props) => props.theme.color.g100};

    @media ${(props) => props.theme.query.min.tablet} {
        padding-top: 50px;
        padding-bottom: 20px;
    }
`

export const WrapperContent = styled.div`
    margin: 0 auto;
    max-width: 1170px;
    width: 100%;
    display: block;
    padding: 0px 15px;
    overflow: hidden;

    @media ${(props) => props.theme.query.min.tablet} {
        display: flex;
        padding: 0;
    }
`

export const Title = styled.div`
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.medium}
    color: ${(props) => props.theme.color.g500};

    padding-bottom: 7px;
`

export const Link = styled(LinkBase)`
    ${(props) => props.theme.typo.bodyS}
    color: ${(props) => props.theme.color.g500};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`

export const LinkWrapper = styled.div`
    padding: 2px 0px;
`

export const SectionWrapper = styled.div`
    padding: 2px 0px;
    max-width: 200px;
    width: 100%;
`

export const LinksWrapper = styled.div`
    margin-bottom: 30px;
`

export const OtherResources = styled.div`
    background: ${(props) => props.theme.color.g100};
    color: ${(props) => props.theme.color.g500};
    padding: 15px;
    cursor: pointer;
    ${(props) => props.theme.typo.bodyM}
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const MobileCollapse = styled.div`
    display: block;

    @media ${(props) => props.theme.query.min.tablet} {
        display: none;
    }
`
export const DesktopLinks = styled.div`
    display: none;

    @media ${(props) => props.theme.query.min.tablet} {
        display: block;
    }
`
